import { datadogRum } from '@datadog/browser-rum';

export type DatadogEventKeys =
  | 'oldProvider'
  | 'newProvider'
  | 'expired'
  | 'renewed'
  | 'added'
  | 'removed'
  | 'error'
  | 'setStorage';

export const DATADOG_EVENTS: Record<DatadogEventKeys, string> = {
  oldProvider: 'dashboard.auth.oldProvider',
  newProvider: 'dashboard.auth.newProvider',
  expired: 'dashboard.auth.tokenExpired',
  renewed: 'dashboard.auth.tokenRenewed',
  added: 'dashboard.auth.tokenAdded',
  removed: 'dashboard.auth.tokenRemoved',
  error: 'dashboard.auth.error',
  setStorage: 'dashboard.auth.setStorage',
};

export const sendDatadogAuthEvent = (event: DatadogEventKeys, context?: object | undefined) => {
  try {
    datadogRum.addAction(DATADOG_EVENTS[event], context);
  } catch {
    // dont need to do anything here, just preventing error from affecting auth
  }
};
